import { CustomSearchParams } from "@/components/common/deep-link/deep-link-encoding";
import { removeSearchParam } from "@/components/common/deep-link/deep-link-utils";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Marks a url rewritten from a WebEditor redirect, so that the origin survives opening it either
 * with a router navigation or with a full page load.
 *
 * @returns the same url, marked
 * @param url the WebEditor link was decoded into
 */
export function addWebEditorRedirectToUrl(url: URL): URL {
  url.searchParams.set(CustomSearchParams.hbRedirect, "");
  return url;
}

/**
 * Reports the redirect once and then drops the marker from the url, so that reloading or sharing
 * it does not greet the user again.
 *
 * @returns true if the viewer was opened through a redirect from the HoloBuilder WebEditor
 */
export function useWasOpenedFromWebEditor(): boolean {
  const [searchParams] = useSearchParams();
  const [wasOpenedFromWebEditor] = useState(() =>
    searchParams.has(CustomSearchParams.hbRedirect),
  );

  useEffect(() => {
    if (wasOpenedFromWebEditor) {
      removeSearchParam(CustomSearchParams.hbRedirect);
    }
  }, [wasOpenedFromWebEditor]);

  return wasOpenedFromWebEditor;
}
